const FIREBASE_CONFIG = {
    apiKey: "AIzaSyBknoMqJqsHchPfThVQTNrM6ImOnoNfdsI",
    authDomain: "auth.checkers.online",
    databaseURL: "https://draughts-42139437.firebaseio.com",
    projectId: "draughts-42139437",
    storageBucket: "draughts-42139437.appspot.com",
    messagingSenderId: "102707651644",
    appId: "1:102707651644:web:4a4c575f57c46c531f0f39",
    measurementId: "G-P6KXFZ3H3B"
};

export default FIREBASE_CONFIG;